import React from "react";
import { newLogo } from "../../assets/Images";

export default function TopChose() {
  const cards = Array.from({ length: 5 }, (_, i) => ({
    id: i + 1,
    title: "Coming Soon",
    subtitle: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...",
  }));

  return (
    <div className="w-full max-w-6xl mx-auto px-6 py-8 mb-8 select-none">
      <h3 className="text-2xl sm:text-3xl font-bold font-oswald text-white uppercase mb-8 border-l-4 border-secondary pl-3">
        Your Top Chose
      </h3>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-5">
        {cards.map((card) => (
          <div
            key={card.id}
            className="group bg-[#0e1118]/80 rounded-lg overflow-hidden border border-neutral-800 hover:border-secondary/40 shadow-lg hover:shadow-secondary/10 transition-all duration-300 flex flex-col"
          >
            {/* Aspect ratio box for image */}
            <div className="aspect-square bg-black relative flex flex-col items-center justify-center p-6 border-b border-neutral-900/60 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60"></div>
              
              <img
                src={newLogo}
                alt="BAB Logo"
                className="object-contain h-1/2 w-1/2 transition-transform duration-500 group-hover:scale-110 mb-2"
              />
              <span className="text-secondary font-oswald text-xs tracking-wider font-semibold uppercase relative z-10">
                {card.title}
              </span>
            </div>

            {/* Content text */}
            <div className="p-4 flex flex-col flex-grow">
              <h4 className="text-white font-outfit text-sm font-semibold mb-1 group-hover:text-secondary transition-colors">
                {card.subtitle}
              </h4>
              <p className="text-neutral-400 font-outfit text-xs leading-relaxed line-clamp-3">
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
